import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, Loader2, Search } from "lucide-react";
import { toast } from "sonner";
import { PageHero } from "@/components/site/PageHero";
import { TextInput } from "@/components/site/Field";
import { api, errMsg } from "@/lib/api";

const CAMPOS = ["Número da OS", "Datas de emissão, visita técnica e prestação do serviço", "Dados do cliente e do veículo", "Serviços selecionados e descrição operacional", "Custo do serviço, deslocamento e valor total", "Forma de pagamento e observações", "Condições do veículo e registro fotográfico", "Condições contratuais e termo de garantia", "Aceite digital com data, hora e IP"];

export default function OrdemServico() {
  const [numero, setNumero] = useState("");
  const [tel, setTel] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const lookup = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/os/lookup", { numero, telefone: tel });
      nav(`/os/${data.share_token}`);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="page-ordem-servico">
      <PageHero eyebrow="Ordem de Serviço - Nillo Ruídos" title="Ordem de Serviço">Consulte, imprima, gere PDF, compartilhe e aceite digitalmente a sua ordem de serviço.</PageHero>
      <section className="mx-auto grid max-w-7xl gap-8 px-4 py-16 sm:px-6 lg:grid-cols-2">
        <form onSubmit={lookup} className="card-tech space-y-4 p-8" data-testid="os-lookup-form">
          <p className="font-heading text-xl font-bold uppercase text-white">Consultar minha OS</p>
          <TextInput label="Número da OS" required value={numero} onChange={setNumero} placeholder="NR-2026-0001" testid="os-lookup-numero" />
          <TextInput label="Telefone informado" required value={tel} onChange={setTel} placeholder="(21) 90000-0000" testid="os-lookup-telefone" />
          <button disabled={busy} className="btn-red" data-testid="os-lookup-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />} Consultar</button>
        </form>
        <div className="card-tech p-8">
          <p className="eyebrow mb-4">O que consta na OS</p>
          <ul className="space-y-2 text-sm text-slate-300">
            {CAMPOS.map((c, i) => <li key={c} className="flex gap-3"><span className="font-mono text-red-500">{String(i + 1).padStart(2, "0")}</span>{c}</li>)}
          </ul>
          <Link to="/orcamento" className="btn-line mt-8" data-testid="os-new-quote">Criar novo orçamento <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </div>
  );
}
